var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassMenu",
    {
      attrs: {
        placement: "top-start",
        trigger: "click",
        customClass: "custom-menu-container",
        disabled: _vm.disabled
      },
      scopedSlots: _vm._u([
        {
          key: "dropdown",
          fn: function() {
            return [
              _c(
                "CompassMenuItem",
                {
                  staticClass: "custom-menu-item",
                  on: {
                    click: function($event) {
                      _vm.getExtensionOption("Unformat").action()
                    }
                  }
                },
                [
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-small-regular" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(_vm.getExtensionOption("Paragraph").label)
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "typographies-paragraph-small-regular option-shortcuts-menu"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              _vm.getExtensionOption("Unformat").shortcuts
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "CompassMenuItem",
                {
                  staticClass: "custom-menu-item",
                  on: {
                    click: function($event) {
                      _vm.getExtensionOption("Blockquote").action()
                    }
                  }
                },
                [
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-small-regular" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              _vm.getExtensionOption("Blockquote").label
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "typographies-paragraph-small-regular option-shortcuts-menu"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              _vm.getExtensionOption("Blockquote").shortcuts
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "CompassMenuItem",
                {
                  staticClass: "custom-menu-item",
                  on: {
                    click: function($event) {
                      _vm.getExtensionOption("Code").action()
                    }
                  }
                },
                [
                  _c(
                    "span",
                    { staticClass: "custom-menu-item__richtext-code" },
                    [
                      _c("code", [
                        _vm._v(
                          _vm._s(
                            _vm.$t.__(_vm.getExtensionOption("Code").label)
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "typographies-paragraph-small-regular option-shortcuts-menu"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(_vm.getExtensionOption("Code").shortcuts)
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "CompassMenuItem",
                {
                  staticClass: "custom-menu-item",
                  on: {
                    click: function($event) {
                      _vm.getExtensionOption("Heading1").action()
                    }
                  }
                },
                [
                  _c("h1", { staticClass: "typographies-heading-h1 heading" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t.__(_vm.getExtensionOption("Heading1").label)
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "typographies-paragraph-small-regular option-shortcuts-menu"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              _vm.getExtensionOption("Heading1").shortcuts
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "CompassMenuItem",
                {
                  staticClass: "custom-menu-item",
                  on: {
                    click: function($event) {
                      _vm.getExtensionOption("Heading2").action()
                    }
                  }
                },
                [
                  _c("h2", { staticClass: "typographies-heading-h2 heading" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t.__(_vm.getExtensionOption("Heading2").label)
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "typographies-paragraph-small-regular option-shortcuts-menu"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              _vm.getExtensionOption("Heading2").shortcuts
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "CompassMenuItem",
                {
                  staticClass: "custom-menu-item",
                  on: {
                    click: function($event) {
                      _vm.getExtensionOption("Heading3").action()
                    }
                  }
                },
                [
                  _c("h3", { staticClass: "typographies-heading-h3 heading" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t.__(_vm.getExtensionOption("Heading3").label)
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "typographies-paragraph-small-regular option-shortcuts-menu"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              _vm.getExtensionOption("Heading3").shortcuts
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "CompassMenuItem",
                {
                  staticClass: "custom-menu-item",
                  on: {
                    click: function($event) {
                      _vm.getExtensionOption("Heading4").action()
                    }
                  }
                },
                [
                  _c("h4", { staticClass: "typographies-heading-h4 heading" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t.__(_vm.getExtensionOption("Heading4").label)
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "typographies-paragraph-small-regular option-shortcuts-menu"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              _vm.getExtensionOption("Heading4").shortcuts
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "CompassMenuItem",
                {
                  staticClass: "custom-menu-item",
                  on: {
                    click: function($event) {
                      _vm.getExtensionOption("Heading5").action()
                    }
                  }
                },
                [
                  _c("h5", { staticClass: "typographies-heading-h5 heading" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t.__(_vm.getExtensionOption("Heading5").label)
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "typographies-paragraph-small-regular option-shortcuts-menu"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              _vm.getExtensionOption("Heading5").shortcuts
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "CompassMenuItem",
                {
                  staticClass: "custom-menu-item",
                  on: {
                    click: function($event) {
                      _vm.getExtensionOption("Heading6").action()
                    }
                  }
                },
                [
                  _c("h6", { staticClass: "typographies-heading-h6 heading" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t.__(_vm.getExtensionOption("Heading6").label)
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "typographies-paragraph-small-regular option-shortcuts-menu"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              _vm.getExtensionOption("Heading6").shortcuts
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.getExtensionOptionLabel(),
            delay: { show: 0, hide: 1 },
            disabled: _vm.disabled,
            placement: "top"
          }
        },
        [
          _c("SelectRichText", {
            attrs: {
              label: _vm.getExtensionOptionLabel(),
              disabled: _vm.disabled,
              active: _vm.activeStyle(_vm.option)
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }